module.exports = __webpack_public_path__ + "static/media/logo-negative.0fe2f1b2.png";